import React, { Component } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ApplicantInfo from './applicantInfo';
import ContactInfo from './contactInfo';
import Residency from './residency';
import Demographics from './demographics';
import AcademicInfo from './academicInfo';
import EducationalHistory from './educationalHistory';
import ToeflScore from './toeflScore';
import ApplicationEssay from './applicationEssay';
import Transcripts from './transcripts';
import References from './references';
import ApplicationFee from './applicationFee';
import Submission from './applicationSubmitted';
import BeginningScreen from './beginningScreen';
import { handleFormStep } from '../../../store/actions/application'

function BayanAppSteps(props){
	const dispatch = useDispatch();
	const { savedSteps, bayanStep } = useSelector((state) => ({
		bayanStep: state.applicationReducer.bayanStep,
		savedSteps: state.applicationReducer.savedSteps
  }), shallowEqual);

  const isLoggedOutUserInfo = !!savedSteps.loggedOutUserInfo && !!Object.keys(savedSteps.loggedOutUserInfo).length
  const isApplicantInfo = !!savedSteps.applicantInfo && !!Object.keys(savedSteps.applicantInfo).length
  const isContactInfo = !!savedSteps.contactInfo && !!Object.keys(savedSteps.contactInfo).length
  const isResidency = !!savedSteps.residency && !!Object.keys(savedSteps.residency).length
  const isDemographics = !!savedSteps.demographics && !!Object.keys(savedSteps.demographics).length
  const isAcademicInfo = !!savedSteps.academicInfo && !!Object.keys(savedSteps.academicInfo).length
  const isEducationalHistory = !!savedSteps.educationalHistory && !!Object.keys(savedSteps.educationalHistory).length
  const isToeflScore = !!savedSteps.toeflScore && !!Object.keys(savedSteps.toeflScore).length
  const isApplicationEssay = !!savedSteps.applicationEssay && !!Object.keys(savedSteps.applicationEssay).length
  const isTranscripts = !!savedSteps.transcripts && !!Object.keys(savedSteps.transcripts).length
  const isReferences = !!savedSteps.references && !!Object.keys(savedSteps.references).length
  const isApplicationFee = !!savedSteps.applicationFee && !!Object.keys(savedSteps.applicationFee).length

  const allDone = () => {
	return isLoggedOutUserInfo && isApplicantInfo && isContactInfo && isResidency && isDemographics && 
		isAcademicInfo && isEducationalHistory && isToeflScore && isApplicationEssay &&
		isTranscripts && isReferences && isApplicationFee;
  }
  const handleAppBeginnigClicked = () => {
	dispatch(handleFormStep('applicantInfo'))
  }
    return(
      <div className="card bayan-steps-wrapper">
      	{
					(bayanStep === 'loggedOutUserInfo') &&
			  <BeginningScreen
				 programs={props.programs} 
				 startApplication={handleAppBeginnigClicked}
			  />
      	}
		{
					(bayanStep === 'applicantInfo') &&
      		<ApplicantInfo />
      	}
      	{
					(bayanStep === 'contactInfo') &&
      		<ContactInfo />
      	}
      	{
					(bayanStep === 'residency') &&
      		<Residency />
      	}
      	{
					(bayanStep === 'demographics') &&
      		<Demographics />
      	}
      	{
					(bayanStep === 'academicInfo') &&
      		<AcademicInfo />
      	}
      	{
					(bayanStep === 'educationalHistory') &&
      		<EducationalHistory />
      	}
      	{
					(bayanStep === 'toeflScore') &&
      		<ToeflScore />
      	}
		{
					(bayanStep === 'applicationEssay') &&
      		<ApplicationEssay />
      	}
		{
					(bayanStep === 'transcripts') &&
      		<Transcripts />
      	}
		{
					(bayanStep === 'references') &&
      		<References />
      	}
		{
					(bayanStep === 'applicationFee') &&
      		<ApplicationFee />
      	}
		{
					(bayanStep === '') && allDone() &&
						<Submission />
      	}
      	</div>
    );
  }


export default BayanAppSteps;
